"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VsdShortcut = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const VsdShortcutSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    clipPath: "url(#vsd-shortcut__a)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#185ABD",
      fillRule: "evenodd",
      d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10.398 14.758c.441.22.965.332 1.494.332 1.557 0 2.543-.796 2.543-1.818 0-.688-.226-1.633-1.679-1.93l-1.17-.261c-.765-.176-.995-.419-.995-.842 0-.585.568-.936 1.283-.936.72 0 1.296.27 1.377 1.044h1.107c-.014-1.053-.873-1.935-2.498-1.935-1.39 0-2.43.77-2.42 1.948.013.95.607 1.517 1.579 1.715l1.197.261c.666.144 1.112.41 1.112.945 0 .603-.635.931-1.44.931-.761 0-1.364-.355-1.508-1.012h-.765q.465.736.783 1.558m-2.581-3.626.925-2.639H7.68l-.708 2.004q.441.293.845.635M4.25 9.284l-.279-.791H2.914l.202.575q.581.072 1.135.216m16.565 2.426c0 2.084-1.094 3.29-3.443 3.29H15.69V8.493h.636l.288.002.296.002c.195 0 .382.003.53.005 2.377.045 3.375 1.21 3.375 3.208m-4.014 2.385h.589c1.337 0 2.277-.634 2.277-2.38 0-1.687-.846-2.318-2.25-2.318h-.616z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "vsd-shortcut__a",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
const VsdShortcut = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: VsdShortcutSvg
}));
exports.VsdShortcut = VsdShortcut;